
define('jst!tasks/tour/_step2',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Assigning tasks #tasksfeaturetour") %></h1>\n\n<p><%= t("You can assign task to others on Podio by starting to type their name here. Picking multiple names will create individual, identical tasks that you can track separately. #tasksfeaturetour") %></p>\n');
 });

